export function dollarsToCents(dollars: number): number {
  return Math.round(dollars * 100);
}
export function centsToDollars(cents: number): number {
  return cents / 100;
}
export function formatCents(cents: number): string {
  const sign = cents < 0 ? '-' : '';
  const abs = Math.abs(cents);
  const dollars = Math.floor(abs / 100);
  const remainder = abs % 100;
  return `${sign}$${dollars}.${remainder.toString().padStart(2, '0')}`;
}
/** Casino convention: vig is 5% of the bet, rounded DOWN to whole dollars. */
export function vigOnAmount(amountCents: number): number {
  const fivePercent = Math.floor(amountCents * 0.05);
  return Math.floor(fivePercent / 100) * 100;
}
